import React from 'react';
import { DropdownLayout as WixDropdownLayout } from '@wix/design-system';

const DropdownLayout = (props) => <WixDropdownLayout {...props} />;

export default DropdownLayout;
